module.exports = {
  cwd() {
    return "/";
  },
  env: {},
  platform: "browser",
};
